import { ICartItem, IProductPagination } from "src/models";
import * as Types from "src/redux/types";

type State = {
  items: ICartItem[];
  isLoaded: boolean;
};

const initialState: State = {
  items: [],
  isLoaded: false,
};

const MartCartReducer = (
  state = initialState,
  action: Action<ICartItem[] | ICartItem | number>
): State => {
  const { type, payload } = action;
  switch (type) {
    case Types.MART_CART_LOAD: {
      const data = payload as ICartItem[];

      return {
        ...state,
        items: data,
        isLoaded: true,
      };
    }

    case Types.MART_CART_ADD_ITEM: {
      const data = payload as ICartItem;
      return {
        ...state,
        items: addOrUpdateItemInCart(state.items, data),
      };
    }
    case Types.MART_CART_UPDATE_ITEM: {
      const data = payload as ICartItem;
      return {
        ...state,
        items: addOrUpdateItemInCart(state.items, data),
      };
    }

    case Types.MART_CART_REMOVE: {
      const id = payload as number;
      return {
        ...state,
        items: state.items.filter((item) => item.product.id !== id),
      };
    }

    case Types.MART_CART_CLEAR: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
};

const addOrUpdateItemInCart = (
  cartItems: ICartItem[],
  cartItem: ICartItem
): ICartItem[] => {
  const existedItem = cartItems.find(
    (item) => item.product.id === cartItem.product.id
  );
  if (existedItem) {
    return cartItems.map((item) =>
      item.product.id === cartItem.product.id ? cartItem : item
    );
  }
  return [...cartItems, cartItem];
};

export default MartCartReducer;
